// extracted by mini-css-extract-plugin
module.exports = {"providerRow":"ProviderListPage_providerRow__1Oq2R"};